import {Component, OnInit} from '@angular/core';
import {NavMenuItem} from '../../../core/models/nav-menu-item.interface';
import {AuthService} from '../../../core/services/auth.service';
import {environment} from '../../../../environments/environment';
import { KfRegistrationService } from 'src/app/kf-data-entry/services/kf-registration.service';
import { PageRequest } from 'src/app/shared/models/page-request.interface';
import { KfConfigurationService } from 'src/app/kf-data-entry/services/kf-configuration.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  hideCharts = environment.hideCharts;
  hasCollectedData: boolean = false;
  private kfcPage: PageRequest = {page: 0, size: 1, sort: 'year', direction: 'desc'};
  private page: PageRequest = {page: 0, size: 4, sort: 'year', direction: 'desc'};

  keyFiguresItems = [
    {
      title: 'View KF WEEE System charts', link: '/kfcharts/weeesystem', icon: 'insert_chart_outlined', class: 'purple',
      roles: ['WF_ADMIN', 'WS_COUNTRY_COORDINATOR', 'WS_ADMIN', 'SIMPLE_USER']
    } as NavMenuItem,
    {
      title: 'View KF Country charts', link: '/kfcharts/country', icon: 'trending_up', class: 'purple',
      roles: ['WF_ADMIN', 'WS_COUNTRY_COORDINATOR', 'WS_ADMIN', 'SIMPLE_USER']
    } as NavMenuItem,
    {title: 'Download KF Data', icon: 'download', class: 'purple',
      roles: ['WF_ADMIN', 'WS_COUNTRY_COORDINATOR', 'WS_ADMIN', 'SIMPLE_USER']
    } as NavMenuItem,
    {
      title: 'Key Figures Configuration Mapping',
      link: '/kfreporting/kfconfiguration/mappings',
      icon: 'table_view',
      class: 'purple',
      roles: ['WF_ADMIN']
    } as NavMenuItem,
    {
      title: 'Key Figures Summary Mapping',
      link: '/kfreporting/kfconfiguration/summary-mappings',
      icon: 'table_view',
      class: 'purple',
      roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN', 'SIMPLE_USER']
    } as NavMenuItem,
  ];

  intelligenceItems = [
    {
      title: 'View Intelligence WEEE System charts',
      link: '/intelligence/weeesystem',
      icon: 'pie_chart_outlined',
      class: 'purple',
      roles: ['WS_COUNTRY_COORDINATOR', 'INTELLIGENCE_CHARTS', 'NO_WF_ADMIN']
    } as NavMenuItem,
    {
      title: 'View Intelligence WEEE System charts',
      link: '/intelligence/weeesystemadmin',
      icon: 'pie_chart_outlined',
      class: 'purple',
      roles: ['WF_ADMIN']
    } as NavMenuItem,
    {
      title: 'View Intelligence Country charts',
      link: '/intelligence/country',
      icon: 'insert_chart_outlined',
      class: 'purple',
      roles: ['WS_COUNTRY_COORDINATOR', 'INTELLIGENCE_CHARTS', 'NO_WF_ADMIN']
    } as NavMenuItem,
    {
      title: 'View Intelligence Country charts',
      link: '/intelligence/countryadmin',
      icon: 'insert_chart_outlined',
      class: 'purple',
      roles: ['WF_ADMIN']
    } as NavMenuItem,
    {
      title: 'Download Country & System at a glance file', icon: 'download', class: 'purple', type: 'intelligence',
      roles: ['WF_ADMIN', 'WS_COUNTRY_COORDINATOR', 'INTELLIGENCE_CHARTS']
    } as NavMenuItem
  ];

  constructor(private authService: AuthService,
              private kfRegistrationService: KfRegistrationService,
              private kfConfigurationService: KfConfigurationService) {
  }

  ngOnInit(): void {
    if (this.authService.userHasAnyRole(['WF_ADMIN'])) {
      this.hasCollectedData = true;
    } else {
      this.kfRegistrationService.getUser(this.authService.getEmail()).subscribe(
        data => {
          this.kfConfigurationService.searchKfConfigurations({launched: true}, this.kfcPage, 'weeesystem').subscribe(
            data2 => {
              if(data2.content.length > 0){
                this.kfRegistrationService.getAllKfRegistrations({weeeSystemId: data.weeeSystem.id, startYear: data2.content[0].year.toString()}, this.page).subscribe(
                  data3 => {
                    let collectedData = data3.content.filter((value) => value.keyFigures == 'Collected')
                                                    .filter((value) => value.status == 'Validated')
                                                    .filter((value) => value.year == data2.content[0].year);

                    this.hasCollectedData = collectedData != null;
                  }
                );
              }
            }
          );
        }
      );
    }
  }

  isVisible(roles?: string[]): boolean {
    if (roles) {
      if (roles.includes('NO_WF_ADMIN') && this.authService.userHasAnyRole(['WF_ADMIN'])) {
        return false
      } else {
        return this.authService.userHasAnyRole(roles);
      }
    }
    return true;
  }

  checkCollectedData(item: NavMenuItem): boolean {
    if (item.link == '/kfcharts/weeesystem') {
      return this.hasCollectedData;
    }
    return true;
  }

}
